import styled from "styled-components/macro";
import { buttonReset, focusVisible } from "../../../styles/a11y";

export const Container = styled.button`
  ${buttonReset}
  ${focusVisible}
  line-height: 19px;
  border-radius: 25px;
  height: 19px;
  width: 19px;
  position: relative;
  color: var(--menu-color-fullscreen) !important;
  display: inline-block;
  cursor: pointer;
  padding: 0px;
  font-weight: bold;
  font-size: 15px;
  text-align: center;
  background: var(--grey-2) !important;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: var(--grey-1) !important;
  }
`;
